{
  "familyId": "TGL-TIJD-SCHEMA",
  "questions": [
    {
      "id": "TGL-TIJD-SCHEMA-001",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "De bus vertrekt om 14:20 en komt aan om 14:55. Hoe lang duurt de rit?",
      "options": ["35 minuten", "25 minuten", "45 minuten", "1 uur en 35 minuten"],
      "correctAnswer": 0,
      "conceptId": "schedule_duration_simple",
      "variantIndex": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ritduur berekenen",
            "content": "Trek de vertrektijd af van de aankomsttijd. 14:55 − 14:20 = 35 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: trek de vertrektijd af van de aankomsttijd. Omdat beide tijden in hetzelfde uur vallen, trek je alleen de minuten af. Stap 1: 55 − 20 = 35 minuten. De rit duurt 35 minuten.",
        "distractorExplanations": {
          "0": "Correct! 14:55 − 14:20 = 35 minuten.",
          "1": "Veelgemaakte fout: de minuten verkeerd aftrekken. 55 − 20 = 35 minuten, niet 25. Controleer: 14:20 + 35 = 14:55 ✓.",
          "2": "Veelgemaakte fout: de minuten verkeerd aftrekken. 55 − 20 = 35 minuten, niet 45. Controleer: 14:20 + 45 = 15:05 ≠ 14:55.",
          "3": "Veelgemaakte fout: een extra uur tellen. Beide tijden zijn in hetzelfde uur (14:xx), dus de rit duurt minder dan 1 uur: 35 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-002",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "De trein vertrekt om 09:15. Je moet 10 minuten voor vertrek op het perron zijn. Hoe laat moet je er zijn?",
      "options": ["09:05", "09:10", "09:25", "08:05"],
      "correctAnswer": 0,
      "conceptId": "schedule_arrive_early",
      "variantIndex": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerder op het perron",
            "content": "Trek 10 minuten af van de vertrektijd: 09:15 − 10 minuten = 09:05.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: als je eerder moet zijn, trek je de tijd af van de vertrektijd. Stap 1: vertrektijd = 09:15. Stap 2: 10 minuten eerder = 09:15 − 10 = 09:05.",
        "distractorExplanations": {
          "0": "Correct! 09:15 − 10 minuten = 09:05.",
          "1": "Veelgemaakte fout: te weinig minuten aftrekken. Je trekt maar 5 minuten af in plaats van 10. 09:15 − 10 = 09:05, niet 09:10.",
          "2": "Veelgemaakte fout: optellen in plaats van aftrekken. Je moet eerder zijn, dus trek af: 09:15 − 10 = 09:05, niet 09:15 + 10 = 09:25.",
          "3": "Veelgemaakte fout: een heel uur aftrekken in plaats van 10 minuten. 09:15 − 10 min = 09:05, niet 09:15 − 1 uur − 10 min = 08:05."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-003",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Je komt aan op het station om 16:30. De volgende bus vertrekt om 16:50. Hoe lang moet je wachten?",
      "options": ["20 minuten", "10 minuten", "30 minuten", "1 uur en 20 minuten"],
      "correctAnswer": 0,
      "conceptId": "schedule_waiting_time",
      "variantIndex": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wachttijd berekenen",
            "content": "Trek de aankomsttijd af van de bustijd: 16:50 − 16:30 = 20 minuten wachten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: wachttijd = vertrektijd bus − aankomsttijd. Omdat beide tijden in hetzelfde uur vallen, trek je alleen de minuten af. Stap 1: 50 − 30 = 20 minuten wachten.",
        "distractorExplanations": {
          "0": "Correct! 16:50 − 16:30 = 20 minuten.",
          "1": "Veelgemaakte fout: de minuten verkeerd aftrekken. 50 − 30 = 20 minuten, niet 10. Controleer: 16:30 + 20 = 16:50 ✓.",
          "2": "Veelgemaakte fout: de minuten verkeerd aftrekken. 50 − 30 = 20 minuten, niet 30. Controleer: 16:30 + 30 = 17:00 ≠ 16:50.",
          "3": "Veelgemaakte fout: een extra uur tellen. Beide tijden zijn in hetzelfde uur (16:xx), dus je wacht minder dan 1 uur: 20 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-004",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Een les begint om 10:00 en eindigt om 10:50. Hoe lang duurt de les?",
      "options": ["50 minuten", "40 minuten", "1 uur", "10 minuten"],
      "correctAnswer": 0,
      "conceptId": "schedule_lesson_duration",
      "variantIndex": 4,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lesduur berekenen",
            "content": "Trek de begintijd af van de eindtijd: 10:50 − 10:00 = 50 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: trek de begintijd af van de eindtijd. Omdat beide tijden in hetzelfde uur vallen, trek je alleen de minuten af. Stap 1: 50 − 0 = 50 minuten. De les duurt 50 minuten.",
        "distractorExplanations": {
          "0": "Correct! 10:50 − 10:00 = 50 minuten.",
          "1": "Veelgemaakte fout: de minuten verkeerd aftrekken. 50 − 0 = 50 minuten, niet 40. Controleer: 10:00 + 50 = 10:50 ✓.",
          "2": "Veelgemaakte fout: afronden naar een heel uur. 1 uur = 60 minuten, maar de les eindigt om 10:50 (niet 11:00). De les duurt 50 minuten.",
          "3": "Veelgemaakte fout: de cijfers omdraaien. 10 minuten is veel te weinig. 10:50 − 10:00 = 50 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-005",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "De metro vertrekt om 13:45 en komt aan om 14:10. Hoe lang duurt de rit?",
      "options": ["25 minuten", "15 minuten", "35 minuten", "1 uur en 25 minuten"],
      "correctAnswer": 0,
      "conceptId": "schedule_duration_cross_hour",
      "variantIndex": 5,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Ritduur over uurgrens",
            "content": "Stap voor stap: 13:45 → 14:00 = 15 minuten. 14:00 → 14:10 = 10 minuten. Totaal: 15 + 10 = 25 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: splits de berekening op bij de uurgrens. Stap 1: 13:45 → 14:00 = 15 minuten (60 − 45 = 15). Stap 2: 14:00 → 14:10 = 10 minuten. Stap 3: totaal = 15 + 10 = 25 minuten.",
        "distractorExplanations": {
          "0": "Correct! 15 + 10 = 25 minuten.",
          "1": "Veelgemaakte fout: alleen het eerste deel tellen. 13:45 → 14:00 = 15 min, maar je moet ook 14:00 → 14:10 = 10 min erbij tellen. Totaal: 25 min.",
          "2": "Veelgemaakte fout: de minuten verkeerd optellen. 15 + 10 = 25 minuten, niet 35. Controleer: 13:45 + 35 = 14:20 ≠ 14:10.",
          "3": "Veelgemaakte fout: een extra uur tellen. De rit gaat over de uurgrens (13 → 14), maar duurt minder dan 1 uur: 25 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-006",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Je moet om 15:30 bij de tandarts zijn. Je wilt 15 minuten voor de afspraak er zijn. Hoe laat moet je aankomen?",
      "options": ["15:15", "15:20", "15:45", "14:15"],
      "correctAnswer": 0,
      "conceptId": "schedule_arrive_before_appointment",
      "variantIndex": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eerder aankomen",
            "content": "Trek 15 minuten af van de afspraaktijd: 15:30 − 15 minuten = 15:15.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: als je eerder moet zijn, trek je de tijd af van de afspraaktijd. Stap 1: afspraak = 15:30. Stap 2: 15 minuten eerder = 15:30 − 15 = 15:15.",
        "distractorExplanations": {
          "0": "Correct! 15:30 − 15 minuten = 15:15.",
          "1": "Veelgemaakte fout: te weinig minuten aftrekken. Je trekt maar 10 minuten af in plaats van 15. 15:30 − 15 = 15:15, niet 15:20.",
          "2": "Veelgemaakte fout: optellen in plaats van aftrekken. Je moet eerder zijn, dus trek af: 15:30 − 15 = 15:15, niet 15:30 + 15 = 15:45.",
          "3": "Veelgemaakte fout: een heel uur aftrekken in plaats van 15 minuten. 15:30 − 15 min = 15:15, niet 15:30 − 1 uur − 15 min = 14:15."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-007",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Een film begint om 19:30 en duurt 1 uur en 45 minuten. Hoe laat is de film afgelopen?",
      "options": ["21:15", "20:15", "21:45", "20:45"],
      "correctAnswer": 0,
      "conceptId": "schedule_end_time_long",
      "variantIndex": 7,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eindtijd berekenen",
            "content": "19:30 + 1 uur = 20:30. Dan + 45 minuten = 21:15.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: tel de uren en minuten apart op bij de begintijd. Let op de uurgrens. Stap 1: 19:30 + 1 uur = 20:30. Stap 2: 20:30 + 45 minuten = 21:15 (30 + 45 = 75 min = 1 uur en 15 min, dus 20 + 1 = 21 uur en 15 min).",
        "distractorExplanations": {
          "0": "Correct! 19:30 + 1 uur + 45 min = 21:15.",
          "1": "Veelgemaakte fout: maar 1 deel van de duur bijtellen. Je telt alleen 45 minuten (19:30 + 45 = 20:15), maar vergeet het uur. 19:30 + 1:45 = 21:15.",
          "2": "Veelgemaakte fout: de minuten verkeerd optellen. 30 + 45 = 75 minuten = 1 uur en 15 min. Dus 20:30 + 45 min = 21:15, niet 22:45.",
          "3": "Veelgemaakte fout: de minuten verkeerd optellen. 30 + 45 = 75 minuten = 1 uur en 15 min. Dus 20:30 + 45 min = 21:15, niet 20:45."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-008",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Je komt aan om 11:40. De volgende trein vertrekt om 12:05. Hoe lang moet je wachten?",
      "options": ["25 minuten", "15 minuten", "35 minuten", "1 uur en 25 minuten"],
      "correctAnswer": 0,
      "conceptId": "schedule_waiting_cross_hour",
      "variantIndex": 8,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wachttijd over uurgrens",
            "content": "Stap voor stap: 11:40 → 12:00 = 20 minuten. 12:00 → 12:05 = 5 minuten. Totaal: 20 + 5 = 25 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: splits de berekening op bij de uurgrens. Stap 1: 11:40 → 12:00 = 20 minuten (60 − 40 = 20). Stap 2: 12:00 → 12:05 = 5 minuten. Stap 3: totaal = 20 + 5 = 25 minuten.",
        "distractorExplanations": {
          "0": "Correct! 20 + 5 = 25 minuten.",
          "1": "Veelgemaakte fout: alleen het eerste deel tellen. 11:40 → 12:00 = 20 min, maar je moet ook 12:00 → 12:05 = 5 min erbij tellen. Totaal: 25 min.",
          "2": "Veelgemaakte fout: de minuten verkeerd optellen. 20 + 5 = 25 minuten, niet 35. Controleer: 11:40 + 35 = 12:15 ≠ 12:05.",
          "3": "Veelgemaakte fout: een extra uur tellen. De wachttijd gaat over de uurgrens (11 → 12), maar duurt minder dan 1 uur: 25 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-009",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Een voetbalwedstrijd begint om 14:00 en eindigt om 15:45. Hoe lang duurt de wedstrijd?",
      "options": ["1 uur en 45 minuten", "1 uur en 35 minuten", "2 uur en 45 minuten", "45 minuten"],
      "correctAnswer": 0,
      "conceptId": "schedule_duration_long",
      "variantIndex": 9,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wedstrijdduur berekenen",
            "content": "14:00 → 15:00 = 1 uur. 15:00 → 15:45 = 45 minuten. Totaal: 1 uur en 45 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: splits de berekening op bij de uurgrens. Stap 1: 14:00 → 15:00 = 1 uur. Stap 2: 15:00 → 15:45 = 45 minuten. Stap 3: totaal = 1 uur en 45 minuten.",
        "distractorExplanations": {
          "0": "Correct! 1 uur + 45 minuten = 1 uur en 45 minuten.",
          "1": "Veelgemaakte fout: de minuten verkeerd tellen. 15:00 → 15:45 = 45 minuten, niet 35. Controleer: 15:00 + 35 = 15:35 ≠ 15:45.",
          "2": "Veelgemaakte fout: een extra uur tellen. 14:00 → 15:00 = 1 uur (niet 2). Totaal: 1 uur en 45 minuten.",
          "3": "Veelgemaakte fout: het hele uur vergeten. 45 minuten is alleen het deel van 15:00 → 15:45. Je vergeet het uur van 14:00 → 15:00."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-010",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "De bus vertrekt om 08:50. Je moet 20 minuten voor vertrek op de bushalte zijn. Hoe laat moet je er zijn?",
      "options": ["08:30", "08:40", "09:10", "07:30"],
      "correctAnswer": 0,
      "conceptId": "schedule_arrive_early_20min",
      "variantIndex": 10,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "20 minuten eerder op de halte",
            "content": "Trek 20 minuten af van de vertrektijd: 08:50 − 20 minuten = 08:30.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: als je eerder moet zijn, trek je de tijd af van de vertrektijd. Stap 1: vertrektijd = 08:50. Stap 2: 20 minuten eerder = 08:50 − 20 = 08:30.",
        "distractorExplanations": {
          "0": "Correct! 08:50 − 20 minuten = 08:30.",
          "1": "Veelgemaakte fout: te weinig minuten aftrekken. Je trekt maar 10 minuten af in plaats van 20. 08:50 − 20 = 08:30, niet 08:40.",
          "2": "Veelgemaakte fout: optellen in plaats van aftrekken. Je moet eerder zijn, dus trek af: 08:50 − 20 = 08:30, niet 08:50 + 20 = 09:10.",
          "3": "Veelgemaakte fout: een heel uur aftrekken in plaats van 20 minuten. 08:50 − 20 min = 08:30, niet 08:50 − 1 uur − 20 min = 07:30."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-011",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Een concert begint om 20:00 en duurt 2 uur en 15 minuten. Hoe laat is het concert afgelopen?",
      "options": ["22:15", "21:15", "22:45", "23:15"],
      "correctAnswer": 0,
      "conceptId": "schedule_end_time_evening",
      "variantIndex": 11,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eindtijd concert berekenen",
            "content": "20:00 + 2 uur = 22:00. Dan + 15 minuten = 22:15.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: tel de uren en minuten apart op bij de begintijd. Stap 1: 20:00 + 2 uur = 22:00. Stap 2: 22:00 + 15 minuten = 22:15.",
        "distractorExplanations": {
          "0": "Correct! 20:00 + 2 uur + 15 min = 22:15.",
          "1": "Veelgemaakte fout: maar 1 uur bijtellen in plaats van 2. 20:00 + 1 uur + 15 min = 21:15. Maar het is 2 uur en 15 min: 22:15.",
          "2": "Veelgemaakte fout: de minuten verkeerd bijtellen. 20:00 + 2 uur = 22:00, dan + 15 min = 22:15, niet 22:45.",
          "3": "Veelgemaakte fout: een extra uur bijtellen. 20:00 + 2 uur = 22:00 (niet 23:00). Dan + 15 min = 22:15."
        }
      }
    },
    {
      "id": "TGL-TIJD-SCHEMA-012",
      "familyId": "TGL-TIJD-SCHEMA",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_schema_lezen",
      "questionType": "multiple_choice",
      "question": "Je komt aan om 17:35. De volgende bus vertrekt om 18:10. Hoe lang moet je wachten?",
      "options": ["35 minuten", "25 minuten", "45 minuten", "1 uur en 35 minuten"],
      "correctAnswer": 0,
      "conceptId": "schedule_waiting_evening",
      "variantIndex": 12,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wachttijd over uurgrens",
            "content": "Stap voor stap: 17:35 → 18:00 = 25 minuten. 18:00 → 18:10 = 10 minuten. Totaal: 25 + 10 = 35 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: splits de berekening op bij de uurgrens. Stap 1: 17:35 → 18:00 = 25 minuten (60 − 35 = 25). Stap 2: 18:00 → 18:10 = 10 minuten. Stap 3: totaal = 25 + 10 = 35 minuten.",
        "distractorExplanations": {
          "0": "Correct! 25 + 10 = 35 minuten.",
          "1": "Veelgemaakte fout: alleen het eerste deel tellen. 17:35 → 18:00 = 25 min, maar je moet ook 18:00 → 18:10 = 10 min erbij tellen. Totaal: 35 min.",
          "2": "Veelgemaakte fout: de minuten verkeerd optellen. 25 + 10 = 35 minuten, niet 45. Controleer: 17:35 + 45 = 18:20 ≠ 18:10.",
          "3": "Veelgemaakte fout: een extra uur tellen. De wachttijd gaat over de uurgrens (17 → 18), maar duurt minder dan 1 uur: 35 minuten."
        }
      }
    }
  ]
}